import Vue from 'vue';

/* eslint-disable */
export default (link) => {
  navigator.clipboard.writeText(link).then(() => {
    Vue.$toast.clear();
    Vue.$toast.success('Copiado com sucesso');
  }).catch((e) => {
    Vue.$toast.clear();
    Vue.$toast.warning(`Copie manualmente: ${link}`);
  });
};
